import {
  RoutesAreasComponents,
  RoutesAreasObject,
} from '@/plugins/1.router/routes/itineraries/areas'
import {
  RoutesReportsComponents,
  RoutesReportsObject,
} from '@/plugins/1.router/routes/itineraries/reports'
import {
  RoutesUpdatesComponents,
  RoutesUpdatesObject,
} from '@/plugins/1.router/routes/itineraries/updates'

export const RoutesItineraries = [
  ...RoutesAreasObject,
  ...RoutesUpdatesObject,
  ...RoutesReportsObject,
]
export default [
  ...RoutesAreasComponents,
  ...RoutesUpdatesComponents,
  ...RoutesReportsComponents,
]
